'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _liteGuid = require('lite-guid');

var _liteGuid2 = _interopRequireDefault(_liteGuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var type = _ref.type;
  var token = _ref.token;
  return 'type:' + type + ',' + ('id:' + _liteGuid2.default.create() + ',') + ('timestamp:' + new Date().toISOString() + ',') + ('tracking:' + token);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-impression-tracking/build/createEventString.js
 ** module id = 42
 ** module chunks = 0
 **/